module.exports = __webpack_public_path__ + "img/icon-copy-dark.bb4fc9a7.svg";